<template lang="pug">
  div
    b-input-group.mb-3
      b-form-input(placeholder="Buscar mensajes...", v-model="search_text", type="search")
      b-input-group-append
        b-input-group-text
          b-spinner(small, variant="primary", v-if="loading")
          search-icon.text-secondary.icon-sm(v-else)
    p.text-secondary.text-center.mt-3(v-if="!loading && !search_messages.length") No se encontraron mensajes

    .overflow-y.scrollable-area.scrollable-container.pt-2.border-bottom.border-top#messages-search-container(v-chat-scroll="{always: false, smooth: true}", v-show="search_messages.length")
      chat-templates(:parsed_conversation_messages="parsed_search_messages", selectable)

</template>

<script>
import { createNamespacedHelpers, mapActions } from 'vuex'
import debounce from 'lodash.debounce'
const conversationController = createNamespacedHelpers('conversation')
const ChatTemplates = () => import('./ChatTemplates.vue')

export default {
  data() {
    return {
      loading: false,
      search_text: '',
      first_message_id: null
    }
  },
  computed: {
    ...conversationController.mapState({
      search_messages: (state) => state.search_messages
    }),
    parsed_search_messages() {
      if (!this.search_messages.length) return
      let last_msg = this.search_messages[0]

      return this.search_messages.map((m) => {
        if (!this.$moment(m.date).isSame(last_msg.date, 'day')) {
          m.new_date = this.$moment(m.date).format('dddd, DD MMMM YYYY')
          last_msg = m
        }
        return m
      })
    }
  },
  methods: {
    ...mapActions(['conversation/searchMessages']),
    searchMessages: debounce(function () {
      const self = this
      this.loading = true
      this['conversation/searchMessages']({
        conversation_id: self.$route.params.conversation_id,
        params: {
          ...self.paginationParams,
          search: self.search_text
        },
        callback: (res) => {
          this.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.parseResponseForPaginationData(res)

            self.$nextTick(() => {
              if (self.first_message_id) {
                const container = $('#messages-search-container')
                const message = $(
                  `#messages-search-container [_id=${self.first_message_id}]`
                ).first()
                if (message) {
                  container.scrollTop(
                    message.offset().top - container.offset().top
                  )
                }
              }

              self.first_message_id = self.search_messages[0]
                ? self.search_messages[0]._id
                : null
            })
          }
        }
      })
    }, 500)
  },
  mounted() {
    const self = this
    $('#messages-search-container').on('scroll', function () {
      const top = $(this).scrollTop()
      if (top == 0 && self.pagination_hasNextPage) {
        self.searchMessages()
      }
    })
  },
  beforeUnmount() {
    // this.$store.commit('conversation/setSearchMessages', [])
  },
  watch: {
    search_text(val) {
      this.resetPagination()
      if (val) {
        this.searchMessages()
      } else {
        this.$store.commit('conversation/setSearchMessages', [])
        this.$store.commit('conversation/selectMessage', null)
      }
    }
  },
  components: { ChatTemplates }
}
</script>

<style lang="scss" scoped>
.scrollable-container {
  max-height: 480px;
  overflow: hidden;
  overflow-y: auto;
  word-break: break-all;
}
</style>
